import React from "react";
import { useNavigate } from "react-router-dom";
import { SUBSCRIPTION_TIERS } from "../../../config/stripeConfig";
import { BmModal, Btn } from "../../ForBrands/ui/BrandUI";
import { usePhoneTheme } from "../../ForBrands/useIsPhone";
import "../../ForBrands/brandMode.css";
import checkSmall from "../../../assets/brand/onboarding/check-11x8.svg";
import arrow from "../../../assets/brand/edit-hub/arrow-18.svg";

// Sign-in upgrade pitch for free-plan athletes, on the shared V2 modal
// (focus trap, Escape and backdrop close, focus handed back on close).
// Shown once per browser session (so it greets them on sign-in without
// nagging on every navigation), gated by Home to free athletes.
const MONTHLY = SUBSCRIPTION_TIERS.ATHLETE_PREMIUM?.pricing?.monthly ?? 4.99;
const FEATURES = [
  { title: "CacheValue™", sub: "Economic valuation" },
  { title: "CacheNILx™", sub: "NIL deal benchmarking" },
  { title: "AI-powered summaries" },
  { title: "Brand matching" },
  { title: "See who viewed your profile" },
];

const AthleteUpgradeModal = ({ open, onClose }) => {
  const navigate = useNavigate();
  const phone = usePhoneTheme();
  if (!open) return null;

  const goUpgrade = () => {
    onClose();
    navigate("/athlete/billing");
  };

  return (
    <BmModal
      title={
        <span className="flex flex-col gap-2">
          <span className="bm-overline !text-bm-orange">Athlete Premium</span>
          <span className={phone ? "bm-h-m" : "bm-h-l"}>Get recruited, get valued, get seen.</span>
        </span>
      }
      onClose={onClose}
      phoneFooterOrder="natural"
      footer={
        <>
          <Btn onClick={goUpgrade} className="gap-[6px]">Start my free trial<img src={arrow} alt="" className="h-[18px] w-[18px] brightness-0 invert" /></Btn>
          <Btn variant="ghost" onClick={onClose}>Maybe later</Btn>
        </>
      }
    >
      <div className="flex flex-col gap-4">
        <p className={`${phone ? "bm-body-m" : "bm-body-l"} text-bm-muted`}>You're on the free plan. Unlock the tools coaches and brands use to evaluate athletes, and see who's looking at you.</p>
        <ul className="rounded-[12px] border border-bm-border bg-white px-[18px]">
          {FEATURES.map((f, i) => (
            <li key={f.title} className={`flex items-center gap-3 py-3 ${i < FEATURES.length - 1 ? "border-b border-bm-mutedbg" : ""}`}>
              <span className="flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full bg-bm-positive"><img src={checkSmall} alt="" className="h-2 w-[11px]" /></span>
              <span className="flex min-w-0 flex-col">
                <span className="bm-label-l text-bm-ink">{f.title}</span>
                {f.sub && <span className="bm-body-s text-bm-muted">{f.sub}</span>}
              </span>
            </li>
          ))}
        </ul>

        <div className="flex flex-col gap-[2px] rounded-[8px] bg-bm-subtle px-4 py-[14px]">
          <span className="bm-label-l text-bm-ink">Start a 5-day free trial</span>
          <span className="bm-body-s text-bm-muted">No credit card required · then ${MONTHLY}/mo · cancel anytime</span>
        </div>
      </div>
    </BmModal>
  );
};

export default AthleteUpgradeModal;
